import React, { Component } from 'react';

// Third Party Components
import { Marker } from 'react-google-maps';

// Components
import iconLuftOntime from '../../../../../../../assets/images/icn_truck-empresa-2-ontime.png';
import iconLuftLaterisk from '../../../../../../../assets/images/icn_truck-empresa-2-laterisk.png';
import iconLuftLate from '../../../../../../../assets/images/icn_truck-empresa-2-late.png';
import iconLuftOntimeFav from '../../../../../../../assets/images/icn_truck-empresa-2-fav-ontime.png';
import iconLuftLateriskFav from '../../../../../../../assets/images/icn_truck-empresa-2-fav-laterisk.png';
import iconLuftLateFav from '../../../../../../../assets/images/icn_truck-empresa-2-fav-late.png';

import iconLuftOntimeApp from '../../../../../../../assets/images/icn_app-empresa-2-ontime.png';
import iconLuftLateriskApp from '../../../../../../../assets/images/icn_app-empresa-2-laterisk.png';
import iconLuftLateApp from '../../../../../../../assets/images/icn_app-empresa-2-late.png';

import iconActiveOntime from '../../../../../../../assets/images/icn_truck-active-ontime.png';
import iconActiveLaterisk from '../../../../../../../assets/images/icn_truck-active-laterisk.png';
import iconActiveLate from '../../../../../../../assets/images/icn_truck-active-late.png';

import iconActiveOntimeApp from '../../../../../../../assets/images/icn_app-active-ontime.png';
import iconActiveLateriskApp from '../../../../../../../assets/images/icn_app-active-laterisk.png';
import iconActiveLateApp from '../../../../../../../assets/images/icn_app-active-late.png';

// util
import { performanceStatus } from '../../../../../../Tracking/utils/delivery-status';

export default class NFMarker extends Component {
  _renderIconUrl = ({
    isKeyAccount,
    status,
    isActive
  }) => {
    if (isActive) {
      switch (status) {
        case performanceStatus.ONTIME:
          return iconActiveOntime;

        case performanceStatus.LATE_RISK:
          return iconActiveLaterisk;

        case performanceStatus.LATE:
          return iconActiveLate;

        default:
          return '';
      }
    }

    switch (status) {
      case performanceStatus.ONTIME:
        return isKeyAccount ? iconLuftOntimeFav : iconLuftOntime;

      case performanceStatus.LATE_RISK:
        return isKeyAccount ? iconLuftLateriskFav : iconLuftLaterisk;

      case performanceStatus.LATE:
        return isKeyAccount ? iconLuftLateFav : iconLuftLate;

      default:
        return '';
    }
  };

  _renderAppIconUrl = ({
    isKeyAccount,
    status,
    isActive
  }) => {
    if (isActive) {
      switch (status) {
        case performanceStatus.ONTIME:
          return iconActiveOntimeApp;

        case performanceStatus.LATE_RISK:
          return iconActiveLateriskApp;

        case performanceStatus.LATE:
          return iconActiveLateApp;

        default:
          return '';
      }
    }

    switch (status) {
      case performanceStatus.ONTIME:
        return isKeyAccount ? iconLuftOntimeFav : iconLuftOntimeApp;

      case performanceStatus.LATE_RISK:
        return isKeyAccount ? iconLuftLateriskFav : iconLuftLateriskApp;

      case performanceStatus.LATE:
        return isKeyAccount ? iconLuftLateFav : iconLuftLateApp;

      default:
        return '';
    }
  };

  render() {
    const {
      position,
      keyAccount,
      onClick,
      shippingGroupId,
      status,
      isActive,
      isAppLocation,
    } = this.props;

    const renderIconParams = {
      keyAccount,
      status,
      shippingGroupId,
      isActive,
    }

    return (
      <Marker
        onClick={onClick}
        position={position}
        icon={{
          url: isAppLocation
            ? this._renderAppIconUrl(renderIconParams)
            : this._renderIconUrl(renderIconParams),
        }}
      />
    );
  }
}
